import React, { useEffect, useState } from "react";
import {
    Alert,
    Box,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CreatorGridService from "../service/CreatorGridService";
import Logger from "../../services/Logger";

const TagsDialog = ({ open, onClose, onTagClick }) => {
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            const fetchTags = async () => {
                setLoading(true);
                try {
                    const fetchedTags = await CreatorGridService.getGridTags('english');
                    setTags(fetchedTags);
                } catch (error) {
                    Logger.error("Error fetching tags:", error);
                    setTags([]);
                } finally {
                    setLoading(false);
                }
            };
            fetchTags();
        } else {
            // Reset tags when dialog closes
            setTags([]);
        }
    }, [open]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Tags List
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Alert severity="info" sx={{ mb: 2 }}>
                    Tags help group and organize puzzles. Puzzles with the same tags will be shown together. 
                    For example, puzzles tagged with "sports" and "hockey" will appear when users search for either tag.
                </Alert>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                        <CircularProgress />
                    </Box>
                ) : tags.length > 0 ? (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, p: 1 }}>
                        {tags.map((tagItem, index) => {
                            const tag = typeof tagItem === 'string' ? tagItem : tagItem.tag;
                            const count = typeof tagItem === 'string' ? null : tagItem.count;
                            return (
                                <Chip
                                    key={index}
                                    label={count !== null ? `${tag} (${count})` : tag}
                                    onClick={() => onTagClick(tag)}
                                    variant="outlined"
                                    sx={{ cursor: 'pointer' }}
                                />
                            );
                        })}
                    </Box>
                ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                        No tags available
                    </Typography>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default TagsDialog;
